// ─────────────────────────────────────────────────────────────────────────
//  ClickViewer · web · 진입점
//
//  ★ 감싸는 순서에 이유가 있다.
//      MantineProvider  — 색·글꼴. 가장 바깥이어야 안쪽 전부가 테마를 본다
//        SessionProvider — /api/me 를 한 번 부른다. 라우터보다 **바깥**이다.
//                          로그인 판정이 주소보다 먼저이기 때문이다(App.tsx 의 관문)
//          RouterProvider — 주소
//            App          — 관문 + 경로표
// ─────────────────────────────────────────────────────────────────────────

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';

// ⚠️ 순서가 중요하다. Mantine 의 기본 스타일을 먼저 넣고 우리 것을 덮는다.
//    반대로 넣으면 global.css 의 색·크기 지정이 조용히 무시된다.
import '@mantine/core/styles.css';
import './global.css';

import { theme } from './theme';
import { SessionProvider } from './auth/SessionProvider';
import { RouterProvider } from './router';
import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('#root 가 없다 — index.html 을 확인해라');

createRoot(root).render(
  <StrictMode>
    {/*
      defaultColorScheme="light" — **auto 가 아니다.**

      ★ 현장은 대부분 야외다. 폰이 어두운 테마로 설정돼 있다고 해서 **햇빛 아래에서
        어두운 화면을 주면 아무것도 안 보인다.** 기기 설정보다 사용 환경이 이긴다.
        어두운 곳(지하·야간)에서 쓰는 사람은 components/ColorScheme.tsx 의 토글로 바꾼다.
        그 선택은 localStorage 에 남아 다음에도 유지된다.
    */}
    <MantineProvider theme={theme} defaultColorScheme="light">
      <SessionProvider>
        <RouterProvider>
          <App />
        </RouterProvider>
      </SessionProvider>
    </MantineProvider>
  </StrictMode>,
);
